export const setDocuments = (documents) => {
    return {
        type:'SET_DOCUMENTS',
        documents
    }
}